import AsyncForm from '../../form/js/async-form.component';
import Notification from '../../../general/js/notification';

export default class PopupResultFormComponent extends AsyncForm {

    onSuccess(result) {
        let notification;
        let template = this.getTemplate();
        if (template !== null) {
            notification = Notification.create(template(result));
        } else {
            notification = Notification.createDefault(result);
        }
        notification.open();
    }

    getTemplate() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/popup-result-form.component.js